import * as tvfCondition from '../services/tvfCondition';

export default {
  namespace: 'tvfCondition',

  state: {
    getTvfRuleList: null,
    addTvfRuleList: null,
    deleteTvfRuleList: null,
    saveTvfRuleList: null,
    editOutputList: null,
    deleteOutputList: null,
    getRuleList: null,
    addOutputList: null,
    deleteRuleList: null,
    saveMultipleRuleList: null,
    deleteMulRuleList: null,
    getHandleList: null,
  },

  effects: {
    *getTvfRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.getTvfRuleList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          getTvfRuleList: response,
        },
      });
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },
    *addTvfRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.addTvfRuleList,
        values,
      );
      console.log(response);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addTvfRuleList: response,
        },
      });
    },
    *deleteTvfRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.deleteTvfRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteTvfRuleList: response,
        },
      });
    },
    *saveTvfRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.saveTvfRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveTvfRuleList: response,
        },
      });
    },

    *editOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.editOutputList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editOutputList: response,
        },
      });
    },
    *addOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(tvfCondition.addOutputList, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          addOutputList: response,
        },
      });
    },
    *deleteOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.deleteOutputList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteOutputList: response,
        },
      });
    },
    *getRuleList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(tvfCondition.getRuleList, values);
      yield put({
        type: 'save',
        payload: {
          getRuleList: response,
        },
      });
    },
    *saveRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(tvfCondition.saveRuleList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveRuleList: response,
        },
      });
    },
    *saveMultipleRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.saveMultipleRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          saveMultipleRuleList: response,
        },
      });
    },
    *deleteRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.deleteRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleList: response,
        },
      });
    },
    *deleteMulRuleList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        tvfCondition.deleteMulRuleList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteMulRuleList: response,
        },
      });
    },
    *getHandleList({ payload: { values } }, { call, put }) {
      const { data: response } = yield call(tvfCondition.getHandleList, values);
      yield put({
        type: 'save',
        payload: {
          getHandleList: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
